import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Header } from "../../components/header/Header";
import { AddVideosAnuncio } from "../../components/AdAnuncio/adAnuncio";
import { MenuOrderingContainer } from "../../components/menuOrdering/menuOrderingContainer";
import { ContextApi } from "../../context/contextApi";
import { DrawerContext } from "../../context/drawerContext";
import { EditDadosAvancados } from "./editDadosAvancados";
import { EditDadosPrincipais } from "./editDadosPrincipais";

import styles from "./style.module.scss";

export function EditingCam(props) {
  let navigate = useNavigate();
  const { cameraId, cookies } = useContext(ContextApi);
  const {
    setShowInnerVideo,
    showInnerVideo,
    setShowMenuOrdering,
    showMenuOrdering,
    setShowUploadVideo,
    setVideoAnuncio,
  } = useContext(DrawerContext);
  const { idCam } = useParams();
  const [infoPrincipais, setInfoPrincipais] = useState(true);
  const [infoAvancadas, setInfoAvancadas] = useState(false);

  function handleCloseMenuOrdering() {
    setShowMenuOrdering(false);
  }

  function checkCredentials() {
    setTimeout(() => {
      if (
        !cookies?.surfViewToken?.token ||
        cookies?.surfViewToken?.userRole === false
      ) {
        navigate("/login");
      }
    }, 2000);
  }

  useEffect(() => {
    checkCredentials();
  }, []);

  function handleCloseInnerVideo() {
    setShowInnerVideo(false);
    setShowUploadVideo(false);
    setVideoAnuncio("");
  }

  return (
    <>
      <Header />
      <div className={styles.containerEditCamera}>
        <div className={styles.boxAbas}>
          <div
            className={
              infoPrincipais
                ? styles.BTNAbaEditCameraActive
                : styles.BTNAbaEditCameraOff
            }
            onClick={() => {
              setInfoPrincipais(true);
              setInfoAvancadas(false);
            }}
          >
            <p>
              Dados camera{" "}
              {cameraId?.nome_camera?.length >= 18
                ? cameraId?.nome_camera?.slice(0, 18) + "..."
                : cameraId?.nome_camera}
            </p>
          </div>
          <div
            className={
              infoAvancadas
                ? styles.BTNAbaEditCameraActive
                : styles.BTNAbaEditCameraOff
            }
            onClick={() => {
              setInfoAvancadas(true);
              setInfoPrincipais(false);
            }}
          >
            <p>informações avançadas</p>
          </div>
        </div>
        {infoPrincipais && <EditDadosPrincipais idCam={idCam} />}
        {infoAvancadas && (
          <EditDadosAvancados
            idCam={idCam}
            setInfoPrincipais={setInfoPrincipais}
            setInfoAvancadas={setInfoAvancadas}
          />
        )}
      </div>
      <AddVideosAnuncio
        showInnerVideo={showInnerVideo}
        handleCloseInnerVideo={handleCloseInnerVideo}
      />
      <MenuOrderingContainer
        showMenuOrdering={showMenuOrdering}
        handleCloseMenuOrdering={handleCloseMenuOrdering}
      />
    </>
  );
}
